
import React from "react";
import { useStateManager } from "@bcm-dev/bcms-vite";
import { SVGAsset } from "res";
import { UIButton } from "components/ui";
import "./styles.css";

export default function ChatTranslationPopup(props) {
  const { ui, onCloseTranslationPopup } = useStateManager();
  const { showTranslationPopup } = ui ?? {};
  const openClass = showTranslationPopup ? "open" : "";

  return (
    <div className={`chat-popup translation-popup ${openClass}`}>
      <div className="translation-popup-container flex-container flex-vertical">
        <div className="flex-container flex-horizontal align-center translation-header">
          <div className="set-width">
            <SVGAsset id="translate" className="material-symbols-outlined translate-icon" />
          </div>
          <div className="flex-width">
            <h2 className="heading-text">Translation</h2>
          </div>
          <div className="set-width clickable" onClick={onCloseTranslationPopup} >
            <SVGAsset id="CloseX" className="icon x-icon" />
          </div>
        </div>
        <div className="translation-select-container flex-container flex-vertical ">
          <label htmlFor="language" className="label">Language</label>
          <select id="language" name="language" className="language-select">
            <option disabled value="">Languages</option>
            <option disabled value="afrikaans">Afrikaans</option>
            <option disabled value="albanian">Albanian</option>
            <option disabled value="amharic">Amharic</option>
            <option disabled value="arabic">Arabic</option>
            <option disabled value="armenian">Armenian</option>
            <option disabled value="azerbaijani">Azerbaijani</option>
            <option disabled value="bengali">Bengali</option>
            <option disabled value="bosnian">Bosnian</option>
            <option disabled value="bulgarian">Bulgarian</option>
            <option disabled value="catalan">Catalan</option>
            <option disabled value="chinese-simplified">Chinese (Simplified)</option>
            <option disabled value="chinese-traditional">Chinese (Traditional)</option>
            <option disabled value="croatian">Croatian</option>
            <option disabled value="czech">Czech</option>
            <option disabled value="danish">Danish</option>
            <option disabled value="dari">Dari</option>
            <option disabled value="dutch">Dutch</option>
            <option value="english">English</option>
            <option disabled value="estonian">Estonian</option>
            <option disabled value="farsi">Farsi (Persian)</option>
            <option disabled value="filipino">Filipino, Tagalog</option>
            <option disabled value="finnish">Finnish</option>
            <option disabled value="french">French</option>
            <option disabled value="french-canada">French (Canada)</option>
            <option disabled value="georgian">Georgian</option>
            <option disabled value="german">German</option>
            <option disabled value="greek">Greek</option>
            <option disabled value="gujarati">Gujarati</option>
            <option disabled value="haitian-creole">Haitian Creole</option>
            <option disabled value="hausa">Hausa</option>
            <option disabled value="hebrew">Hebrew</option>
            <option disabled value="hindi">Hindi</option>
            <option disabled value="hungarian">Hungarian</option>
            <option disabled value="icelandic">Icelandic</option>
            <option disabled value="indonesian">Indonesian</option>
            <option disabled value="irish">Irish</option>
            <option disabled value="italian">Italian</option>
            <option disabled value="japanese">Japanese</option>
            <option disabled value="kannada">Kannada</option>
            <option disabled value="kazakh">Kazakh</option>
            <option disabled value="korean">Korean</option>
            <option disabled value="latvian">Latvian</option>
            <option disabled value="lithuanian">Lithuanian</option>
            <option disabled value="macedonian">Macedonian</option>
            <option disabled value="malay">Malay</option>
            <option disabled value="malayalam">Malayalam</option>
            <option disabled value="maltese">Maltese</option>
            <option disabled value="marathi">Marathi</option>
            <option disabled value="mongolian">Mongolian</option>
            <option disabled value="norwegian">Norwegian (Bokmål)</option>
            <option disabled value="pashto">Pashto</option>
            <option disabled value="polish">Polish</option>
            <option disabled value="portuguese-brazil">Portuguese (Brazil)</option>
            <option disabled value="portuguese-portugal">Portuguese (Portugal)</option>
            <option disabled value="punjabi">Punjabi</option>
            <option disabled value="romanian">Romanian</option>
            <option disabled value="russian">Russian</option>
            <option disabled value="serbian">Serbian</option>
            <option disabled value="sinhala">Sinhala</option>
            <option disabled value="slovak">Slovak</option>
            <option disabled value="slovenian">Slovenian</option>
            <option disabled value="somali">Somali</option>
            <option disabled value="spanish">Spanish</option>
            <option disabled value="spanish-mexico">Spanish (Mexico)</option>
            <option disabled value="swahili">Swahili</option>
            <option disabled value="swedish">Swedish</option>
            <option disabled value="tamil">Tamil</option>
            <option disabled value="telugu">Telugu</option>
            <option disabled value="thai">Thai</option>
            <option disabled value="turkish">Turkish</option>
            <option disabled value="ukrainian">Ukrainian</option>
            <option disabled value="urdu">Urdu</option>
            <option disabled value="uzbek">Uzbek</option>
            <option disabled value="vietnamese">Vietnamese</option>
            <option disabled value="welsh">Welsh</option>
          </select>
        </div>
        <div className="flex-container flex-horizontal align-center button-container">
          <UIButton text="Save" className="save-button chat-button flex-width clickable" onClick={onCloseTranslationPopup} />
        </div>
      </div>
    </div>
  )
}
